import axios from 'axios';

// Configure axios defaults for all requests
// Note: Vite proxies /api to localhost:4000, so we use relative paths
axios.defaults.withCredentials = true;

// Create a separate axios instance for internal auth checks to prevent interceptor recursion
const authAxios = axios.create({
    withCredentials: true
});

const AUTH_REDIRECT_KEY = 'auth_redirect_attempted';

// Add response interceptor to handle 401 errors globally
axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            // Check if we've already attempted a redirect/reload to prevent loops
            if (sessionStorage.getItem(AUTH_REDIRECT_KEY)) {
                console.error('[Auth] Already attempted auth redirect/reload. Aborting to prevent loop.');
                console.error('[Auth] Please check server configuration and refresh manually.');
                return Promise.reject(error);
            }

            // Mark that we're attempting a redirect
            sessionStorage.setItem(AUTH_REDIRECT_KEY, Date.now().toString());

            // On 401, fetch the auth URL and redirect
            // Use authAxios to avoid infinite recursion if auth-url also returns 401
            try {
                const {data} = await authAxios.get('/api/config/auth-url');
                if (data.authUrl) {
                    console.log('[Auth] Redirecting to auth URL:', data.authUrl);
                    window.location.href = data.authUrl;
                }
            } catch (e) {
                console.error('[Auth] Failed to fetch auth URL:', e);
                // Fallback: just reload the page if we can't get the auth URL
                window.location.reload();
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
